export enum FormType {
  HEATCOOL = "HeatingCoolingFormBlockLink",
  CONDENSER = "CondenserFormBlockLink",
  VAPORIZER = "ReboilerFormBlockLink",
  REQUEST_QUOTE = "RequestQuoteFormLink"
}

export enum ChoiceTypes {
  BUTTON = "Button",
  LARGE_BUTTON = "LargeButton",
  CHECKBOX = "Checkbox",
  RADIO = "Radio",
  SLIDER = "Slider",
}

export enum ChoiceLayout {
  HORIZONTAL = "Horizontal",
  VERTICAL = "Vertical",
}


export type IndustryListItem = {
  Title: string;
  Description?: string;
};

export type PageQuestionOption = {
  Caption: string;
  Value: string;
  Checked: boolean;
  ValueRelevantTo?: string;
};

export type PageQuestionCondition = {
  Field?: string;
  FieldValue?: string;
  Operation?: string;
};

export type PageQuestion = {
  AllowsNegative?: false;
  ContentType?: string;
  Description?: string;
  Label?: string;
  MeasurementUnit?: string;
  ValidationUnit?: string;
  Validators?: string;
  CheckboxLayout?: string;
  Feed?: string;
  Options?: PageQuestionOption[];
  Max?: number;
  Min?: number;
  PredefinedValue?: string;
  Step?: number;
  AllowMultiSelect?: boolean;
  ConditionCombination?: number | string;
  Tooltip?: string;
  conditionQuestions?: ConditionQuestion[];
  CheckboxType?: ChoiceTypes;
  CheckboxOrientation?: ChoiceLayout;
  ChoiceName?: string;
  Conditions?: PageQuestionCondition[];
  List?: IndustryListItem[] | CountryDropDownList[];
  ParagraphText?: string;
  FieldId?: string
};

export type ConditionQuestion = PageQuestion;

export type PageSections = {
  description?: string;
  label?: string;
  title?: string;
  questions?: PageQuestion[];
  determineFurtherQuestions?: boolean
  isSubmit?: boolean
  isLastStep?: boolean

};

export type PageForms = {
  image?: string;
  sections?: PageSections[];
  title?: string;
  type?: FormType;
  description?: string;
  formGuid?: string;
  resultIcon?: string;
  antiForgeryToken?: string;
  id?: string;
};

export type HexpertModalProps = {
  ModalButtonText?: string
  ModalConfirmationDescription?: string
  ModalConfirmationHeading?: string
  ModalDescription?: string
  ModalHeading?: string
  ModalImage?: { Url?: string }
  ModalQuoteText?: string
  ModalTextboxPlaceholder?: string
  ModalUsp?: string
  Modal?: boolean
}



export type IndustryType = {
  Caption: string;
  Value: string | number;
  Checked: boolean;
  Title: string;
  Description?: string;
};


export type PageFormsElementsConditionData = {
  FieldValue?: string;
  Operation?: string;
  Field?: string;
};

export type CountryDropDownList = {
  Country: string;
  Email: string;
}

export type PageFormsElementsData = {
  List: CountryDropDownList[] | IndustryListItem[];
  ContentType?: string;
  Label?: string;
  SeparatorDescription?: string;
  Title?: string;
  Conditions?: PageFormsElementsConditionData[];
  DetermineFurtherQuestions?: boolean
  FieldId?: string;
  FieldName?: string;
  PredefinedValue?: string;
  Validators?: string;
};

export type PageFormsValueData = {
  ContentType?: string;
  ElementsArea?: PageFormsElementsData[];
  Title?: string;
  PreviewImage?: { Url?: string };
  GuidValue?: string
  Type?: string,
  SubmitSuccessMessage?: string,
  ResultImage?: {
    Url?: string
  },
  Id?: string
};

export type PageFormsData = {
  Key: FormType;
  Value?: PageFormsValueData;
};

export type PageProps = {
  Description?: string;
  IntroDescription?: string;
  IntroText?: string;
  MetaTitle?: string;
  StartLabel?: string;
  HexpertBackLabel?: string;
  HexpertContinueLabel?: string;
  HexpertUnitsLabel?: string;
  HexpertImperialRadioButton?: string;
  HexpertMetricRadioButton?: string;
  HexpertStandardRadioButton?: string;
  HexpertBarLabel?: string;
  SubTitle?: string;
  Title?: string;
  HeatingCoolingFormBlockLink?: string
  CondenserFormFormBlockLink?: string
  ReboilerFormBlockLink?: string
  PageId?: number
  cookie?: string
  Forms?: PageFormsData[];
  NoResultButtonLabel?: string
  NoResultDescription: string
  NoResultTitle: string,
  EnquireTitle: string,
  EnquireDescription: string,
  PersonalInformationTitle: string,

  InternalEmail?: string,
} & HexpertModalProps;

export type PageStateProps = PageProps & {
  MappedForms?: PageForms[];
  fieldsToCheckInResult?: string[]
};

export type PageData = PageProps & {
  Forms?: PageFormsData[];
}